"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTime = void 0;
const getTime = () => {
    const d = new Date();
    const hours = ('0' + (d.getHours() % 12)).slice(-2);
    const minutes = ('0' + d.getMinutes()).slice(-2);
    const seconds = ('0' + d.getSeconds()).slice(-2);
    return `${hours}:${minutes}:${seconds}`;
};
exports.getTime = getTime;
exports.default = exports.getTime;
//# sourceMappingURL=getTime.js.map